export const ROOT_VIEW_NAME = 'WEB_ROOT'

export const HIDDEN_VIEW_NAMES = new Set([
  'HR_ROTATIONS',
  'HR_ROTATIONS_GROUP',
  'HR_ROTATIONS_CALENDAR',
  'HR_ROTATIONS_TEMPLATES',
  'HR_ROTATIONS_CONFLICTS',
  // Temporarily hidden from sidebar regardless of view permissions
  'ANALYTICS_GROUP',
  'CALLS_GROUP',
  'DOCUMENTS_MENU',
  'STORAGE_GROUP',
  'STORAGE_MAIN',
  'STORAGE_MENU',
])

export const MODULE_PERMISSION_GROUPS = {
  crm: ['CRM_GROUP', 'ADMIN_GROUP'],
  hr: ['HR_GROUP', 'ADMIN_GROUP'],
  documents: ['DOCUMENTS_MENU', 'ADMIN_GROUP'],
  timesheet: ['TIMESHEET_GROUP', 'ADMIN_GROUP'],
  wallet: ['WALLET_MENU', 'ADMIN_GROUP'],
  billing: ['BILLING_MENU', 'ADMIN_GROUP'],
  media: ['MEDIA_PANEL', 'ADMIN_GROUP'],
} as const
